// @flow
import styled from 'styled-components';

export const Pagination = styled.ul`
    display: flex;
    justify-content: center;
    margin: 0;
    padding: 0;
`;

export const Item = styled.li`
    background-color: ${({ active, theme }) => (active ? theme.mediumGrey : theme.lightGrey)};
    border-radius: 8px;
    height: 8px;
    list-style: none;
    margin: 0 2px;
    width: 8px;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/mode-selector-slide/pagination/styles.js